/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindTimeTrackingQueryResponse } from './FindTimeTrackingQueryResponse';
import {
    FindTimeTrackingQueryResponseFromJSON,
    FindTimeTrackingQueryResponseFromJSONTyped,
    FindTimeTrackingQueryResponseToJSON,
} from './FindTimeTrackingQueryResponse';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';

/**
 * 
 * @export
 * @interface ListTimeTrackingQueryResponse
 */
export interface ListTimeTrackingQueryResponse {
    /**
     * 
     * @type {ListMeta}
     * @memberof ListTimeTrackingQueryResponse
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<FindTimeTrackingQueryResponse>}
     * @memberof ListTimeTrackingQueryResponse
     */
    data: Array<FindTimeTrackingQueryResponse>;
}

/**
 * Check if a given object implements the ListTimeTrackingQueryResponse interface.
 */
export function instanceOfListTimeTrackingQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ListTimeTrackingQueryResponseFromJSON(json: any): ListTimeTrackingQueryResponse {
    return ListTimeTrackingQueryResponseFromJSONTyped(json, false);
}

export function ListTimeTrackingQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTimeTrackingQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'data': ((json['data'] as Array<any>).map(FindTimeTrackingQueryResponseFromJSON)),
    };
}

export function ListTimeTrackingQueryResponseToJSON(value?: ListTimeTrackingQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'data': ((value.data as Array<any>).map(FindTimeTrackingQueryResponseToJSON)),
    };
}

